import { Component, OnInit, Inject } from '@angular/core';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Voucher } from 'src/app/models/voucher';
import { VoucherService } from 'src/app/services/voucher.service';

@Component({
  selector: 'app-selecionar-voucher-modal',
  templateUrl: './selecionar-voucher-modal.component.html',
  styleUrls: ['./selecionar-voucher-modal.component.scss']
})
export class SelecionarVoucherModalComponent implements OnInit {

  idCliente;
  vouchers: Voucher[] = [];
  vouchersValidos: Voucher[] = [];
  vouchersInvalidos: Voucher[] = [];
  codigo: string;
  valorTotalPedido: number;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private notificaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private voucherService: VoucherService,
    private dialogRef: MatDialogRef<SelecionarVoucherModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(this.data) {
      this.idCliente = this.data.idCliente;
      this.valorTotalPedido = this.data.valorTotalPedido;
    }
  }

  ngOnInit(): void {
    this.buscarVochersIntegrador();
  }

  buscarVochersIntegrador() {
    this.carregandoService.mostra('buscarVochersIntegrador');

    this.voucherService.consultarPorIdCliente(this.idCliente).subscribe(
      vouchers => {
        this.vouchers = vouchers;
        this.carregandoService.esconde('buscarVochersIntegrador');
        this.vouchersValidos = this.vouchers.filter(p => p.estaValido && this.valorTotalPedido >= p.valorMinimoPedido);
        this.vouchersInvalidos = this.vouchers.filter(p => !p.estaValido || this.valorTotalPedido < p.valorMinimoPedido);
        this.vouchersInvalidos.map(p => p.estaValido = false);
      },
      err => {
        this.carregandoService.esconde('buscarVouchersIntegrador');
        this.notificaoService.erro(err);
      }
    );
  }

  adicionarVoucher() {
    this.carregandoService.mostra('adicionarVoucher');

    this.voucherService.vincularCliente(this.idCliente, this.codigo).subscribe(
      () => {
        this.carregandoService.esconde('adicionarVoucher');
        this.codigo = '';
        this.buscarVochersIntegrador();
      },
      err => {
        this.carregandoService.esconde('adicionarVoucher');
        this.notificaoService.erro(err);
      }
    );

  }

  selecionar(voucher) {
    this.dialogRef.close(voucher);
  }

  fechar() {
    this.dialogRef.close();
  }
}
